import { render } from "./ExportadoresPage.vue?vue&type=template&id=0c4d2f88&scoped=true"
import script from "./ExportadoresPage.vue?vue&type=script&lang=js"
export * from "./ExportadoresPage.vue?vue&type=script&lang=js"

import "./ExportadoresPage.vue?vue&type=style&index=0&id=0c4d2f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4d2f88"]])

export default __exports__